import nav from "./nav.json";
import navSearch from "./navSearch.json";
import topNav from "./topNav.json";

export default {
  nav,
  navSearch,
  topNav,
};
